import React from 'react'
import styled from 'styled-components'

import logoDesktop from '../../assets/images/logo-full-white.png'
import logoMobile from '../../assets/images/logo-white.png'

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

export const Logo = () => {
  return (
    <Wrapper>
      {isMobile ? (
        <img src={logoMobile} height="40" alt="logo" />
      ) : (
        <img src={logoDesktop} height="40" alt="logo" />
      )}
    </Wrapper>
  )
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 3px;
`

export default Logo



// WEBPACK FOOTER //
// ./src/components/Logo/index.js